import React from "react";
import { Link } from "react-router-dom";

const LearningGoals = (props) => (
  <>
    {/* Learning Goals Section (light card) */}
    <section className="bg-white border-l-8 border-cyan-400 p-8 rounded-xl shadow-lg mb-10">
      <h2 className="text-2xl font-extrabold text-cyan-700 mb-3 tracking-tight uppercase">
        Learning Goals
      </h2>
      <ul className="list-disc list-inside text-lg text-gray-800 space-y-2 pl-4">
        <li>
          <span className="font-bold text-cyan-700">Design & Build:</span>{" "}
          Master drivetrain design, gear ratios, and hands-on building skills.
        </li>
        <li>
          <span className="font-bold text-cyan-700">CAD & Documentation:</span>{" "}
          Complete a full CAD model and document your process in your
          engineering notebook.
        </li>
        <li>
          <span className="font-bold text-cyan-700">Code Like a Pro:</span>{" "}
          Program your drivetrain using VEXcode IQ, from basic movement to
          advanced control loops.
        </li>
        <li>
          <span className="font-bold text-cyan-700">Sensor Integration:</span>{" "}
          Use gyro sensors for precision and learn the basics of PID control.
        </li>
        <li>
          <span className="font-bold text-cyan-700">Reflect & Improve:</span>{" "}
          Analyze your design and code, and iterate for better performance.
        </li>
      </ul>
      <p className="mt-6 text-base text-gray-500 italic">
        By the end of this unit, you'll have a fully functional drivetrain, a
        detailed CAD model, and a notebook full of engineering insights!
      </p>
    </section>
    <h3 className="text-lg font-semibold text-cyan-700 mb-6 uppercase tracking-widest">
      Unit 2: Drivetrain, Coding, and PID
    </h3>
    {/* Teaching Aid Robot Section (light card) */}
    <div className="bg-white border-l-4 border-cyan-200 p-6 rounded-lg shadow mb-8">
      <h4 className="text-xl font-bold text-cyan-700 mb-2">Meet Your Robot!</h4>
      <p className="text-gray-700 mb-2">
        Get a sneak peek at the teaching aid robot—the final product you'll
        build! We'll demo all its features so you can see what you're working
        toward.
      </p>
      <img
        src="/imgs/units/robot_demo.jpg"
        alt="Teaching Aid Robot"
        className="w-full max-w-md mx-auto rounded-lg shadow mt-4 border-2 border-cyan-100"
      />
    </div>
    {/* Getting Set Up Section (light card) */}
    <div className="bg-white border-l-4 border-cyan-100 p-6 rounded-lg shadow mb-8">
      <h4 className="text-lg font-semibold text-cyan-700 mb-2">
        Getting Set Up
      </h4>
      <ul className="list-disc list-inside text-gray-700 space-y-2">
        <li>
          How each chapter is formatted: lessons, hands-on activities, and
          challenges
        </li>
        <li>How assignments work on Google Classroom</li>
        <li>How to use your Engineering Notebook to document your journey</li>
      </ul>
    </div>
    {/* Lessons Preview Section (light card) */}
    <div className="bg-white border-l-4 border-cyan-100 p-6 rounded-lg shadow mb-8">
      <h4 className="text-lg font-semibold text-cyan-700 mb-2">
        What's Ahead in Unit 2?
      </h4>
      <ol className="list-decimal list-inside text-gray-700 space-y-2 mb-2">
        <li>
          <span className="font-bold text-cyan-700">
            Lesson 1: Intro to Drivetrain
          </span>{" "}
          <br />
          <span className="text-sm">
            Explore drivetrain design, gear ratios, and see the teaching aid
            robot in action.
          </span>
        </li>
        <li>
          <span className="font-bold text-cyan-700">
            Lesson 2: Building the Drivetrain
          </span>{" "}
          <br />
          <span className="text-sm">
            Build your drivetrain, integrate your chosen gear ratio, and
            document your choices.
          </span>
        </li>
        <li>
          <span className="font-bold text-cyan-700">
            Lesson 3: Coding the Drivetrain
          </span>{" "}
          <br />
          <span className="text-sm">
            Program your drivetrain in VEXcode IQ, from setup to basic movement
            and control.
          </span>
        </li>
        <li>
          <span className="font-bold text-cyan-700">
            Lesson 4: Gyro Sensors
          </span>{" "}
          <br />
          <span className="text-sm">
            Integrate and code with gyro sensors for precision and new
            challenges.
          </span>
        </li>
        <li>
          <span className="font-bold text-cyan-700">Lesson 5: PID</span> <br />
          <span className="text-sm">
            Learn about PID control, tune your robot, and program it to drive in
            a square.
          </span>
        </li>
      </ol>
    </div>
  </>
);

export default LearningGoals;
